import axios from "axios";
import * as Actions from "@/store/actions.type";
import * as Mutations from "@/store/mutations.type";
import apiClient from "@/common/gateway-api";

export default {
  /**
   *
   * @desc Action to search for instance according to keyword
   * @param {string} keyword The searching keyword
   *
   */
  [Actions.GLOBAL_SEARCH_INSTANCE]({ commit }, { region, keyword }) {
    try {
      commit(Mutations.SET_GLOBAL_SEARCH_LOADING, true);
      apiClient
        .get(`/api/v1/woo/components/instances/search`, {
          params: { region, keyword }
        })
        .then((res) => {
          commit(Mutations.SET_GLOBAL_SEARCH_LOADING, false);
          const getComponentId = (name) => {
            const component_id = components.find((item) => {
              return item.name === name;
            }).id;
            return component_id;
          };
          const category = JSON.parse(
            localStorage.getItem("abi_category")
          ).data;
          const components = JSON.parse(
            localStorage.getItem(`abi_${region}_components`)
          ).data;

          let results = res.data.data;
          category.forEach((item) => {
            results = results.filter((result) => {
              return (
                result.instance_name !=
                  `${getComponentId("abi_faq")}|${item.name}` &&
                result.instance_name !=
                  `${getComponentId("abi_category_faq")}|${item.name}` &&
                result.instance_name !=
                  `${getComponentId("abi_category")}|${item.name}` &&
                result.instance_name !=
                  `${getComponentId("abi_content_text_block")}|faqs_${
                    item.name
                  }` &&
                result.instance_name !=
                  `${getComponentId("abi_content_text_block")}|assistance_${
                    item.name
                  }` &&
                result.instance_name !=
                  `${getComponentId("abi_content_text_block")}|range_${
                    item.name
                  }` &&
                result.instance_name != `6|overview_${item.name}`
              );
            });
          });
          commit(Mutations.SET_GLOBAL_SEARCH_RESULT, results);
          if (!keyword) {
            commit(Mutations.SET_GLOBAL_SEARCH_RESULT, []);
          }
        })
        .catch((err) => {
          throw err.message;
        });
    } catch (err) {
      commit(Mutations.SET_GLOBAL_SEARCH_LOADING, false);
      commit(Mutations.SET_DATA_ERROR, err || "Unable To Search ");
    }
  },
  /**
   *
   * @desc Action to clear global search result
   *
   */
  [Actions.CLEAR_GLOBAL_SEARCH_RESULT]({ commit }) {
    commit(Mutations.SET_GLOBAL_SEARCH_RESULT, []);
  },
  /**
   *
   * @desc Action to update component instance name
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   * @param {string} instanceId The id of the instance
   * @param {string} instanceName The name of the instance
   *
   */
  [Actions.UPDATE_INSTANCE_NAME](
    { commit },
    { region, componentId, instanceId, draftId, instanceName }
  ) {
    // change the instance name and draft at the same time {{{
    const editInstanceNameRequest =
      instanceId &&
      apiClient.put(
        `/api/v1/woo/components/instances/name/${instanceId}`,
        { instanceName, comp_id: componentId },
        { params: { region } }
      );
    const editDraftNameRequest =
      draftId &&
      apiClient.put(
        `/api/v1/woo/components/instances/draft/name/${instanceId}`,
        { instanceName, comp_id: componentId },
        { params: { region } }
      );
    // }}}
    try {
      Promise.all(
        draftId
          ? [editDraftNameRequest, editInstanceNameRequest]
          : [editInstanceNameRequest]
      ).catch((err) => {
        throw err.message;
      });
    } catch (err) {
      commit(Mutations.SET_DATA_ERROR, err || "Unable to edit ");
    }
  },
  /**
   *
   * @desc Action to update component instance name
   * @param {string} region The current region
   * @param {string} description The description of the instance
   * @param {string} instanceName The name of the instance
   *
   */
  [Actions.UPDATE_INSTANCE_DESCRIPTION](
    { commit },
    { region, description, instanceId }
  ) {
    apiClient
      .put(
        `/api/v1/woo/components/instances/description/${instanceId}`,
        { description },
        { params: { region } }
      )
      .catch((err) => {
        commit(Mutations.SET_DATA_ERROR, err.message || "Unable to edit ");
      });
  },
  /**
   *
   * @desc Action to create cache for instance description
   * @param {string} description The description
   * @param {string} instanceId The instance id
   *
   */
  [Actions.SET_DESCRIPTION_CACHE]({ commit }, { description, instanceId }) {
    commit(Mutations.SET_INSTANCE_DESCRIPTION, { description, instanceId });
  },
  /**
   *
   * @desc Action to fetch the component data, including attributes and instances
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_COMPONENT_DATA]({ commit }, { region, componentId }) {
    commit(Mutations.CLEAR_COMPONENT_INFO);
    commit(Mutations.SET_DATA_LOADING, true);
    // fetch component attributes
    const getAttributesRequest = apiClient.get(
      `/api/v1/woo/components/${componentId}/attributes`,
      { params: { region } }
    );
    // fetch instance information
    const getInstanceInfoRequest = apiClient.get(
      `/api/v1/woo/components/${componentId}/instances`,
      { params: { region } }
    );
    // fetch instance draft
    const getInstanceDraftRequest = apiClient.get(
      `/api/v1/woo/components/${componentId}/instances/draft`,
      { params: { region } }
    );
    return new Promise((resolve, reject) => {
      Promise.all([
        getAttributesRequest,
        getInstanceInfoRequest,
        getInstanceDraftRequest
      ])
        .then((response) => {
          commit(Mutations.SET_BASIC_ATTRIBUTES, response[0].data.data);
          commit(Mutations.SET_ADDITIONAL_ATTRIBUTES, response[0].data.data);
          commit(Mutations.SET_ALL_ATTRIBUTES, response[0].data.data);
          commit(Mutations.SET_INSTANCE_INFO, response[1].data.data);
          commit(Mutations.SET_INSTANCE_DRAFT, response[2].data.data);
          commit(Mutations.SET_DATA_LOADING, false);
          resolve(response);
        })
        .catch((error) => {
          commit(Mutations.SET_DATA_ERROR, error.message);
          commit(Mutations.SET_DATA_LOADING, false);
          reject(error);
        });
    });
  },
  /**
   *
   * @desc Action to fetch the component attributes
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_COMPONENT_ATTRIBUTES]({ commit }, { region, componentId }) {
    commit(Mutations.SET_DATA_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/attributes`, {
        params: { region }
      })
      .then((res) => {
        commit(Mutations.SET_BASIC_ATTRIBUTES, res.data.data);
        commit(Mutations.SET_ADDITIONAL_ATTRIBUTES, res.data.data);
        commit(Mutations.SET_ALL_ATTRIBUTES, res.data.data);
        commit(Mutations.SET_DATA_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_DATA_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to clear the component attributes
   *
   */
  [Actions.CLEAR_COMPONENT_ATTRIBUTES]({ commit }) {
    commit(Mutations.SET_BASIC_ATTRIBUTES, {});
    commit(Mutations.SET_ADDITIONAL_ATTRIBUTES, {});
    commit(Mutations.SET_ALL_ATTRIBUTES, {});
  },
  /**
   *
   * @desc Action to fetch the component instance info
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_INSTANCE_INFO]({ commit }, { region, componentId }) {
    commit(Mutations.SET_DATA_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/instances`, {
        params: { region }
      })
      .then((res) => {
        commit(Mutations.SET_INSTANCE_INFO, res.data.data);
        commit(Mutations.SET_DATA_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_DATA_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to fetch the component instance info to be sync
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_SYNC_INSTANCE_INFO]({ commit }, { region, componentId }) {
    commit(Mutations.SET_SYNC_DATA_FETCH_LOADING, { region, loading: true });
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/api/v1/woo/components/${componentId}/instances`, {
          params: { region }
        })
        .then((res) => {
          commit(Mutations.SET_SYNC_INSTANCE_INFO, {
            region,
            instanceInfo: res.data.data
          });
          commit(Mutations.SET_SYNC_DATA_FETCH_LOADING, {
            region,
            loading: false
          });
          resolve();
        })
        .catch((error) => {
          commit(Mutations.SET_DATA_ERROR, error.message);
          commit(Mutations.SET_SYNC_DATA_FETCH_LOADING, {
            region,
            loading: false
          });
          reject();
        });
    });
  },
  /**
   *
   * @desc Action to fetch the intro component instance info (abi_cat_intro_shortcode)
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_INTRO_INSTANCE_INFO]({ commit }, { region, componentId }) {
    commit(Mutations.SET_INTRO_DATA_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/instances`, {
        params: { region }
      })
      .then((res) => {
        commit(Mutations.SET_INTRO_INSTANCE_INFO, res.data.data);
        commit(Mutations.SET_INTRO_DATA_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_INTRO_DATA_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to update the component instance
   * @param {object} formData The data of the update form
   * @param {string} region The current region
   * @param {string} instanceId The id of the instance
   * @param {string} user The current user
   *
   */
  [Actions.UPDATE_COMPONENT_DATA](
    { commit },
    { formData, region, instanceId, user, currentUrl }
  ) {
    commit(Mutations.SET_SAVE_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .put(
          `/api/v1/woo/components/instances/${instanceId}`,
          {
            formData,
            user
          },
          { params: { region } }
        )
        .then(() => {
          commit(Mutations.SET_SAVE_LOADING, false);
          commit(Mutations.SET_DATA_SUCCESS, `Instance Updated Success!`);
          setTimeout(() => {
            commit(Mutations.SET_DATA_SUCCESS, null);
          }, 5000);
          axios({
            method: "POST",
            url: "https://eov4uoewwgf8ts8.m.pipedream.net",
            data: {
              region,
              user,
              currentUrl
            }
          });
          resolve();
        })
        .catch(() => {
          commit(
            Mutations.SET_DATA_ERROR,
            "Unable to update, please try again later"
          );
          reject();
          commit(Mutations.SET_SAVE_LOADING, false);
        });
    });
  },
  /**
   *
   * @desc Action to copy the component instance
   * @param {object} formData The data of the update form
   * @param {object} title The title of the instance
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.COPY_COMPONENT_DATA](
    { commit },
    { formData, title, region, componentId, user }
  ) {
    commit(Mutations.SET_COPY_LOADING, true);
    const data = { attributes: formData, instance_name: `${title}_copy` };
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/api/v1/woo/components/${componentId}/instances`,
          { formData: data, user },
          {
            params: { region }
          }
        )
        .then(() => {
          commit(Mutations.SET_COPY_LOADING, false);
          resolve();
        })
        .catch((error) => {
          commit(Mutations.SET_COPY_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
          reject(error);
        });
    });
  },
  /**
   *
   * @desc Action to delete the component instance
   * @param {string} region The current region
   * @param {string} instanceId The id of the instance
   *
   */
  [Actions.DELETE_COMPONENT_DATA](
    { commit },
    { region, instanceId, draftId, index }
  ) {
    commit(Mutations.SET_DELETE_LOADING, { loading: true, index });
    const deleteInstanceRequest =
      instanceId &&
      apiClient.delete(`/api/v1/woo/components/instances/${instanceId}`, {
        params: { region }
      });
    const deleteDraftRequest =
      draftId &&
      apiClient.delete(`/api/v1/woo/components/instances/draft/${draftId}`, {
        params: { region }
      });

    Promise.all(
      draftId
        ? [deleteInstanceRequest, deleteDraftRequest]
        : [deleteInstanceRequest]
    )
      .then(() => {
        commit(Mutations.REMOVE_INSTANCE_INFO, instanceId);
        if (draftId) {
          commit(Mutations.REMOVE_DRAFT_INFO, draftId);
        }
        commit(Mutations.SET_DELETE_LOADING, { loading: false, index });
      })
      .catch(() => {
        commit(
          Mutations.SET_DATA_ERROR,
          "Unable to delete, please try again later"
        );
        commit(Mutations.SET_DELETE_LOADING, { loading: false, index });
      });
  },
  /**
   *
   * @desc Action to create the component instance
   * @param {object} formData The data of the create form
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.CREATE_COMPONENT_DATA](
    { commit },
    { formData, region, componentId, user }
  ) {
    commit(Mutations.SET_CREATE_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/api/v1/woo/components/${componentId}/instances`,
          { formData, user },
          { params: { region } }
        )
        .then(() => {
          commit(Mutations.SET_CREATE_LOADING, false);
          resolve();
        })
        .catch((error) => {
          commit(Mutations.SET_CREATE_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.response.data.data);
          reject(error);
        });
    });
  },
  /**
   *
   * @desc Action to change operation mode
   *
   */
  [Actions.CHANGE_OPERATION_MODE]({ commit }, { operation }) {
    commit(Mutations.SET_OPERATION_MODE, operation);
  },
  /**
   *
   * @desc Action to clear error message
   *
   */
  [Actions.CLEAR_COMPONENT_ERRORS]({ commit }) {
    commit(Mutations.SET_DATA_ERROR, "");
  },
  /**
   *
   * @desc Action to clear success message
   *
   */
  [Actions.CLEAR_COMPONENT_SUCCESS]({ commit }) {
    commit(Mutations.SET_DATA_SUCCESS, "");
  },
  /**
   *
   * @desc Action to add error message
   *
   */
  [Actions.ADD_COMPONENT_ERRORS]({ commit }, error) {
    commit(Mutations.SET_DATA_ERROR, error);
  },
  /**
   *
   * @desc Action to set instance search keyword
   *
   */
  [Actions.SEARCH_INSTANCE]({ commit }, search) {
    commit(Mutations.SET_INSTANCE_SEARCH, search);
  },
  /**
   *
   * @desc Action to set current instance list page number
   *
   */
  [Actions.INSTANCE_SET_PAGE]({ commit }, page) {
    commit(Mutations.SET_INSTANCE_PAGE, page);
  },

  // ********************* abi image slider *********************

  /**
   *
   * @desc Action to fetch slide instance
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_SLIDE_INSTANCE]({ commit }, { region, componentId }) {
    commit(Mutations.SET_DATA_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/instances`, {
        params: { region }
      })
      .then((res) => {
        commit(Mutations.SET_SLIDE_INSTANCE, res.data.data);
        commit(Mutations.SET_DATA_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_DATA_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to fetch slide attributes
   * @param {string} region The current region
   * @param {string} componentId The id of the component
   *
   */
  [Actions.FETCH_SLIDE_ATTRIBUTES]({ commit }, { region, componentId }) {
    commit(Mutations.SET_SLIDE_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/attributes`, {
        params: { region }
      })
      .then((res) => {
        commit(Mutations.SET_SLIDE_ATTRIBUTES, res.data.data);
        commit(Mutations.SET_SLIDE_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_SLIDE_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to create slider instance
   * @param {string} region The current region
   * @param {object} formData The form data of slider create form
   * @param {string} componentId The id of the component
   * @param {string} user The current user
   *
   */
  async [Actions.CREATE_SLIDER_INSTANCE](
    { commit },
    { region, formData, componentId, user, currentUrl }
  ) {
    let slidesUpdateRequests = [];
    const formDataCopy = JSON.parse(JSON.stringify(formData));
    const slidesInstance = formDataCopy.slider.attributes.slides.map(
      (item) => item.instance
    );
    formDataCopy.slider.attributes.slides = slidesInstance;
    commit(Mutations.SET_SLIDER_CREATE_LOADING, true);
    let slideData = formDataCopy.slider;
    try {
      // 1. create a new instance for abi image slider
      await apiClient
        .post(
          `/api/v1/woo/components/${componentId}/instances`,
          { formData: slideData, user },
          { params: { region } }
        )
        .catch((error) => {
          commit(Mutations.SET_SLIDER_CREATE_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
          Promise.reject(error);
        });

      // 2. Update the selected image slides
      slidesInstance.forEach((item, index) => {
        let slideInstance = formDataCopy[index];
        slidesUpdateRequests.push(
          apiClient.put(
            `/api/v1/woo/components/instances/${slidesInstance[index]}`,
            { formData: slideInstance, user },
            { params: { region } }
          )
        );
      });
      await Promise.all(slidesUpdateRequests)
        .then(() => {
          commit(Mutations.SET_SLIDER_CREATE_LOADING, false);
          axios({
            method: "POST",
            url: "https://eov4uoewwgf8ts8.m.pipedream.net",
            data: {
              region,
              user,
              currentUrl
            }
          });
          return Promise.resolve();
        })
        .catch((error) => {
          commit(Mutations.SET_SLIDER_CREATE_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
          Promise.reject(error);
        });
    } catch {
      (error) => {
        commit(Mutations.SET_SLIDER_CREATE_LOADING, false);
        commit(
          Mutations.SET_DATA_ERROR,
          "Unknown error, please try again later"
        );
        Promise.reject(error);
      };
    }
  },
  /**
   *
   * @desc Action to update slider instance
   * @param {string} region The current region
   * @param {object} formData The form data of slider update form
   * @param {string} instanceId The id of the instance
   * @param {string} user The current user
   *
   */
  async [Actions.UPDATE_SLIDER_INSTANCE](
    { commit },
    { region, formData, instanceId, user, currentUrl }
  ) {
    let slidesUpdateRequests = [];
    const formDataCopy = JSON.parse(JSON.stringify(formData));
    const slidesInstance = formDataCopy.slider.slides.map(
      (item) => item.instance
    );
    formDataCopy.slider.slides = slidesInstance;
    let sliderData = formDataCopy.slider;
    commit(Mutations.SET_SLIDER_UPDATE_LOADING, true);
    try {
      // 1. Update the abi image slider
      await apiClient
        .put(
          `/api/v1/woo/components/instances/${instanceId}`,
          {
            formData: sliderData,
            user
          },
          { params: { region } }
        )
        .catch((error) => {
          commit(Mutations.SET_SLIDER_UPDATE_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
        });

      // 2. Update the selected image slides
      slidesInstance.forEach((item, index) => {
        let slideInstance = formDataCopy[index];

        slidesUpdateRequests.push(
          apiClient.put(
            `/api/v1/woo/components/instances/${slidesInstance[index]}`,
            { formData: slideInstance, user },
            { params: { region } }
          )
        );
      });
      await Promise.all(slidesUpdateRequests)
        .then(() => {
          commit(Mutations.SET_SLIDER_UPDATE_LOADING, false);
          commit(Mutations.SET_DATA_SUCCESS, `Slider Updated Success!`);
          setTimeout(() => {
            commit(Mutations.SET_DATA_SUCCESS, null);
          }, 5000);
          axios({
            method: "POST",
            url: "https://eov4uoewwgf8ts8.m.pipedream.net",
            data: {
              region,
              user,
              currentUrl
            }
          });
        })
        .catch((error) => {
          commit(Mutations.SET_SLIDER_UPDATE_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
        });
    } catch {
      () => {
        commit(Mutations.SET_SLIDER_UPDATE_LOADING, false);
        commit(
          Mutations.SET_DATA_ERROR,
          "Unknown error, please try again later"
        );
      };
    }
  },
  /**
   *
   * @desc Action to copy slider instance
   * @param {string} region The current region
   * @param {object} formData The form data of slider update form
   * @param {string} componentId The id of the component
   * @param {string} title The title of the component
   *
   */
  async [Actions.COPY_SLIDER_INSTANCE](
    { commit },
    { region, formData, componentId, title, user }
  ) {
    const formDataCopy = JSON.parse(JSON.stringify(formData));
    const slidesInstance = formDataCopy.slider.slides.map(
      (item) => item.instance
    );
    formDataCopy.slider.slides = slidesInstance;
    commit(Mutations.SET_SLIDER_COPY_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/api/v1/woo/components/${componentId}/instances`,
          {
            formData: {
              attributes: formDataCopy.slider,
              instance_name: `${title}_copy`
            },
            user
          },
          { params: { region } }
        )
        .then(() => {
          commit(Mutations.SET_SLIDER_COPY_LOADING, false);
          resolve();
        })
        .catch((error) => {
          commit(Mutations.SET_SLIDER_COPY_LOADING, false);
          commit(Mutations.SET_DATA_ERROR, error.message);
          reject(error);
        });
    });
  },
  // ************************* draft **************************
  /**
   *
   * @desc Action to set edit mode
   * @param {string} status The status to be set
   *
   */
  [Actions.SET_DRAFT_MODE]({ commit }, { status }) {
    commit(Mutations.SET_DRAFT_MODE_STATUS, status);
  },
  [Actions.FETCH_DRAFT_INFO]({ commit }, { region, componentId }) {
    commit(Mutations.SET_DATA_LOADING, true);
    apiClient
      .get(`/api/v1/woo/components/${componentId}/instances/draft`, {
        params: { region }
      })
      .then((response) => {
        commit(Mutations.SET_INSTANCE_DRAFT, response.data.data);
        commit(Mutations.SET_DATA_LOADING, false);
      })
      .catch((error) => {
        commit(Mutations.SET_DATA_ERROR, error.message);
        commit(Mutations.SET_DATA_LOADING, false);
      });
  },
  /**
   *
   * @desc Action to create draft instance
   * @param {string} region The current region
   * @param {object} formData The form data of draft
   * @param {string} componentId The id of the component
   *
   */
  [Actions.CREATE_DRAFT_INSTANCE](
    { commit },
    { region, componentId, formData, user }
  ) {
    commit(Mutations.SET_DRAFT_CREATE_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/api/v1/woo/components/${componentId}/instances/draft`,
          {
            formData,
            user
          },
          { params: { region } }
        )
        .then(() => {
          commit(Mutations.SET_DRAFT_CREATE_LOADING, false);
          resolve();
        })
        .catch(() => {
          reject();
          commit(
            Mutations.SET_DATA_ERROR,
            "Unable to update, please try again later"
          );
          commit(Mutations.SET_DRAFT_CREATE_LOADING, false);
        });
    });
  },
  /**
   *
   * @desc Action to update draft instance
   * @param {string} region The current region
   * @param {object} formData The form data of draft
   * @param {string} draftId The id of the draft
   *
   */
  [Actions.UPDATE_DRAFT_INSTANCE](
    { commit },
    { region, draftId, formData, user }
  ) {
    commit(Mutations.SET_DRAFT_SAVE_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .put(
          `/api/v1/woo/components/instances/draft/${draftId}`,
          { formData, user },
          { params: { region } }
        )
        .then(() => {
          commit(Mutations.SET_DRAFT_SAVE_LOADING, false);
          commit(Mutations.SET_DATA_SUCCESS, `Draft Updated Success!`);
          setTimeout(() => {
            commit(Mutations.SET_DATA_SUCCESS, null);
          }, 5000);
          resolve();
        })
        .catch(() => {
          commit(
            Mutations.SET_DATA_ERROR,
            "Unable to update, please try again later"
          );
          commit(Mutations.SET_DRAFT_SAVE_LOADING, false);
          reject();
        });
    });
  },
  // ************************* Notice **************************
  /**
   *
   * @desc Action to fetch email delay message
   * @param {string} region The current region
   *
   */
  [Actions.FETCH_DELAY_MESSAGE]({ commit }, { region }) {
    return new Promise((resolve, reject) => {
      commit(Mutations.SET_FETCH_DELAY_MESSAGE_LOADING, true);
      apiClient
        .get(`/api/v1/woo/components/email-delay-message`, {
          params: { region }
        })
        .then((res) => {
          commit(Mutations.SET_DELAY_MESSAGE, res.data.delayMessage);
          commit(Mutations.SET_FETCH_DELAY_MESSAGE_LOADING, false);
          resolve();
        })
        .catch(() => {
          commit(Mutations.SET_FETCH_DELAY_MESSAGE_LOADING, false);
          reject();
        });
    });
  },
  /**
   *
   * @desc Action to update email delay message
   * @param {string} region The current region
   * @param {object} data The form data
   *
   */
  [Actions.UPDATE_DELAY_MESSAGE]({ commit }, { region, data }) {
    commit(Mutations.SET_DELAY_MESSAGE_LOADING, true);
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/api/v1/woo/components/email-delay-message`, data, {
          params: { region }
        })
        .then(() => {
          commit(Mutations.SET_DELAY_MESSAGE_LOADING, false);
          resolve();
        })
        .catch(() => {
          commit(Mutations.SET_DELAY_MESSAGE_LOADING, false);
          reject();
        });
    });
  },
  /**
   *
   * @desc Action to sync the instance
   * @param {string} oldName The previous name of the instance
   * @param {object} shouldUpdate whether user should update the instance
   * @param {object} selectedOptions the list of selected regions
   * @param {object} newNameList the list of new instance names
   * @param {object} formData the form data of the instance
   *
   */
  [Actions.SYNC_COMPONENT_INSTANCE](
    { commit, state },
    { oldName, shouldUpdate, selectedOptions, newNameList, formData, user }
  ) {
    commit(Mutations.SET_SYNC_LOADING, true);
    return new Promise((resolve, reject) => {
      let requests = [];
      let instanceName = oldName.split("|")[1];
      let componentId = oldName.split("|")[0];
      selectedOptions.forEach((region) => {
        if (
          state.syncCompInstanceInfo[region].find(
            (item) => item.instance_name === oldName
          )
        ) {
          if (shouldUpdate[region] === "yes") {
            let instanceId = state.syncCompInstanceInfo[region].find(
              (item) => item.instance_name === oldName
            ).id;
            // should overwrite the previous instance
            requests.push(
              apiClient.put(
                `/api/v1/woo/components/instances/${instanceId}`,
                { formData, user },
                { params: { region } }
              )
            );
          } else {
            let newName = newNameList[region];
            // create new instance with the new name
            requests.push(
              apiClient.post(
                `/api/v1/woo/components/${componentId}/instances`,
                {
                  formData: {
                    attributes: formData,
                    instance_name: newName
                  },
                  user
                },
                { params: { region } }
              )
            );
          }
        } else {
          // create new instance with the old name
          requests.push(
            apiClient.post(
              `/api/v1/woo/components/${componentId}/instances`,
              {
                formData: {
                  attributes: formData,
                  instance_name: instanceName
                },
                user
              },
              { params: { region } }
            )
          );
        }
      });
      Promise.all(requests)
        .then(() => {
          commit(Mutations.SET_SYNC_LOADING, false);
          resolve();
        })
        .catch(() => {
          commit(
            Mutations.SET_DATA_ERROR,
            "Unable to sync, please try again later"
          );
          commit(Mutations.SET_SYNC_LOADING, false);
          reject();
        });
    });
  },
  /**
   *
   * @desc Action to sync the blog instance
   * @param {string} oldName The previous name of the instance
   * @param {object} shouldUpdate whether user should update the instance
   * @param {object} selectedOptions the list of selected regions
   * @param {object} newNameList the list of new instance names
   * @param {object} formData the form data of the instance
   * @param {string} componentId the id of the blog component
   *
   */
  [Actions.SYNC_BLOG_INSTANCE](
    { commit, state },
    {
      selectedOptions,
      shouldUpdate,
      formData,
      newNameList,
      oldName,
      componentId,
      user
    }
  ) {
    return new Promise((resolve, reject) => {
      // function to generate the random id
      const makeid = () => {
        return Math.floor(Math.random() * 90000) + 10000;
      };

      commit(Mutations.SET_SYNC_LOADING, true);
      let Requests = [];
      let childComponentsInfo = formData.components;
      selectedOptions.forEach(async (region) => {
        if (
          state.syncCompInstanceInfo[region].find(
            (item) => item.instance_name === oldName
          )
        ) {
          if (shouldUpdate[region] === "yes") {
            let blogComponents = [];
            let blogAttributes = JSON.parse(JSON.stringify(formData.blog));
            // 1.create copy for child components
            childComponentsInfo.forEach((component, index) => {
              let childComponents =
                blogAttributes["abi_blog_components"].split(",");
              let randomId = makeid();
              let newName = "";
              if (/^.*-s-\d{5}.*$/.test(childComponents[index])) {
                newName =
                  childComponents[index].slice(0, -8) + `-s-${randomId}`;
              } else {
                newName = childComponents[index] + `-s-${randomId}`;
              }
              blogComponents.push(newName);
              Requests.push(
                apiClient.post(
                  `/api/v1/woo/components/${component.componentId}/instances`,
                  {
                    formData: {
                      attributes: component.attributes,
                      instance_name: newName.split("|")[1]
                    },
                    user
                  },
                  { params: { region } }
                )
              );
            });

            // 2.update the blog instance
            blogAttributes["abi_blog_components"] = blogComponents.join(",");
            let instanceId = state.syncCompInstanceInfo[region].find(
              (item) => item.instance_name === oldName
            ).id;
            Requests.push(
              apiClient.put(
                `/api/v1/woo/components/instances/${instanceId}`,
                { formData: blogAttributes, user },
                { params: { region } }
              )
            );
          } else {
            let blogComponents = [];
            let blogAttributes = JSON.parse(JSON.stringify(formData.blog));
            // 1.create copy for child components
            childComponentsInfo.forEach((component, index) => {
              let childComponents =
                blogAttributes["abi_blog_components"].split(",");
              let randomId = makeid();
              let newName = childComponents[index] + `-s-${randomId}`;
              blogComponents.push(newName);
              Requests.push(
                apiClient.post(
                  `/api/v1/woo/components/${component.componentId}/instances`,
                  {
                    formData: {
                      attributes: component.attributes,
                      instance_name: newName.split("|")[1]
                    },
                    user
                  },
                  { params: { region } }
                )
              );
            });
            // 2.create blog with newName
            let newName = newNameList[region];
            blogAttributes["abi_blog_components"] = blogComponents.join(",");
            Requests.push(
              apiClient.post(
                `/api/v1/woo/components/${componentId}/instances`,
                {
                  formData: {
                    attributes: blogAttributes,
                    instance_name: newName
                  },
                  user
                },
                { params: { region } }
              )
            );
          }
        } else {
          // create new instance with the old name
          let blogComponents = [];
          let blogAttributes = JSON.parse(JSON.stringify(formData.blog));
          // 1.create copy for child components
          childComponentsInfo.forEach((component, index) => {
            let childComponents =
              blogAttributes["abi_blog_components"].split(",");
            let randomId = makeid(5);
            let newName = childComponents[index] + `-s-${randomId}`;
            blogComponents.push(newName);
            Requests.push(
              apiClient.post(
                `/api/v1/woo/components/${component.componentId}/instances`,
                {
                  formData: {
                    attributes: component.attributes,
                    instance_name: newName.split("|")[1]
                  },
                  user
                },
                { params: { region } }
              )
            );
          });
          // 2.create blog with newName
          blogAttributes["abi_blog_components"] = blogComponents.join(",");
          Requests.push(
            apiClient.post(
              `/api/v1/woo/components/${componentId}/instances`,
              {
                formData: {
                  attributes: blogAttributes,
                  instance_name: oldName.split("|")[1]
                },
                user
              },
              { params: { region } }
            )
          );
        }
      });
      Promise.all(Requests)
        .then(() => {
          resolve();
          commit(Mutations.SET_SYNC_LOADING, false);
        })
        .catch(() => {
          reject();
          commit(Mutations.SET_SYNC_LOADING, false);
        });
    });
  }
};
